import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-gen-header',
    standalone: false,
    templateUrl: './gen-header.component.html',
    styleUrl: './gen-header.component.scss'
})
export class GenHeaderComponent {

    @Input({ required: true }) streamName: string = ""
    @Input({ required: true }) streamType: string = ""
}
